import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { initSentry } from './lib/sentryInit';
import { SentryFallback } from './components/SentryFallback';
import App from './App';
import './index.css';

// Self-hosted fonts — exact-pinned per DesignSystem.md §13.4.
// Inter weights cover body (400/500), bold accents (700), and font-black (900).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/900.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
// Space Grotesk for display headings.
import '@fontsource/space-grotesk/700.css';

// Initialise Sentry before any React rendering so window.onerror /
// unhandledrejection are patched to capture early errors. No-op when DSN is empty.
initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
